import type { ThemeWithoutTokens } from '../theme.types';

export const treeTokens = (theme: ThemeWithoutTokens) =>
  ({
    treeItemPaddingLeft: theme.space.component.x.m,
    treeTextColor: theme.palette.grey600,
    treeErroredTextColor: theme.colors.danger.normal,
  }) as const;
